//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: 'wash',
  components: {
  },
  data () {
    return {
      type:1,
      count:[],
    }
  },
  created(){
    this.getOrderCount();
  
  },
  mounted(){

  },
  methods:{
    getOrderCount(){
      this.$api.getOrderCount({type:this.type,deliveryWay:1}).then((res)=>{
        this.count = res.data;
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/washHome.vue